<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
        <mat-drawer class="w-72 dark:bg-gray-900 no-shadow flex flex-col h-full" [mode]="drawerMode" [opened]="drawerOpened" #drawer>
            <!-- Contenido desplazable -->
            <div class="flex-1 overflow-y-auto">

            <!-- Mailbox sidebar -->

            <fuse-card class="flex items-center max-w-80 w-full p-6 filter-info">
                <mat-icon class="icon-size-12 mr-6" [svgIcon]="'heroicons_outline:bookmark'"></mat-icon>
                <div class="flex flex-col">
                    <div class="text-2xl font-semibold leading-tight">Lista de Facturas</div>
                    <div class="text-md text-secondary">Búsqueda avanzada</div>
                </div>
            </fuse-card>


            <div class="ml-3 mr-3">
                <div class="col-sm-12  mt-6 mb-1">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 mr-3" [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                            <span class="leading-none"><small>Periodo</small></span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select [placeholder]="'Año'" [formControl]="frmAnio"
                            (selectionChange)="onYearChange($event)">
                            <mat-option value="0">-</mat-option>
                            <mat-option value="{{item}}" *ngFor="let item of anios">{{item}}</mat-option>
                        </mat-select>
                        <!-- <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:calendar'"></mat-icon> -->
                    </mat-form-field>
                </div>
                <div class="col-sm-12">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select [placeholder]="'Mes'" [formControl]="frmMes">
                            <mat-option value="Todos">-</mat-option>
                            <mat-option value="{{item}}" *ngFor="let item of meses">{{item}}</mat-option>
                        </mat-select>

                    </mat-form-field>
                </div>

                <div class="col-sm-12  mt-4 mb-1">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 mr-3" [svgIcon]="'heroicons_outline:user-group'"></mat-icon>
                            <span class="leading-none"><small>RFC</small></span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <input matInput aria-label="State" [matAutocomplete]="auto" [formControl]="stateCtrl">
                        <mat-autocomplete #auto="matAutocomplete" panelClass="custom-autocomplete-panel">
                            <mat-option *ngFor="let state of filteredStates | async" [value]="state.rfc" style="height: 35px;">
                                <span>{{ state.rfc }} - {{ state.nombre }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="col-sm-12  mt-6 mb-1">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 mr-3"
                                [svgIcon]="'heroicons_outline:lightning-bolt'"></mat-icon>
                            <span class="leading-none"><small>Generales</small></span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select [placeholder]="'Lugar de expedición'" [formControl]="frmExpedicion">
                            <mat-option value="0">-</mat-option>
                            <mat-option value="0">Todos</mat-option>
                            <mat-option value="{{item.id}}"
                                *ngFor="let item of lugarExpedicion">({{item.attributes.dir_direccion.data ?
                                item.attributes.dir_direccion.data.attributes.codigoPostal: ''}})
                                {{item.attributes.nombre}}</mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:library'"></mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-sm-12">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select [placeholder]="'Tipo comprobante'" [formControl]="frmDocumento">
                            <mat-option value="0">-</mat-option>
                            <mat-option value="0">Todas</mat-option>
                            <mat-option value="{{item.id}}"
                                *ngFor="let item of tipoComprobante">{{item.attributes.nombre}}</mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:color-swatch'"></mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-sm-12">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select [placeholder]="'Status'" [formControl]="frmEstatus">
                            <mat-option value="0">-</mat-option>
                            <mat-option value="0">Todos</mat-option>
                            <mat-option value="{{item.id}}"
                                *ngFor="let item of estatusFactura">{{item.attributes.nombre}}</mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:badge-check'"></mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-sm-12">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <mat-select [placeholder]="'Método de pago'" [formControl]="frmPago">
                            <mat-option value="0">-</mat-option>
                            <mat-option value="0">Todos</mat-option>
                            <mat-option value="{{item.id}}"
                                *ngFor="let item of metodoPago">{{item.attributes.clave}}</mat-option>
                        </mat-select>
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:cash'"></mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-sm-12  mt-6 mb-1">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 mr-3" [svgIcon]="'heroicons_outline:collection'"></mat-icon>
                            <span class="leading-none"><small>Folios</small></span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="flex-auto gt-xs:pr-3">
                                <input matInput [formControl]="frmFolioInicio" [placeholder]="'Folio inicial'">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="flex-auto gt-xs:pr-3">
                                <input matInput [formControl]="frmFolioFin" [placeholder]="'Folio final'">
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12  mt-6 mb-1" *ngIf="false">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 mr-3" [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                            <span class="leading-none"><small>Rango de fecha</small></span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 mt-4" *ngIf="false">
                    <mat-form-field appearance="fill">
                        <mat-label>Fecha inicial</mat-label>
                        <input matInput [matDatepicker]="picker" [placeholder]="'Folio inicial'" disabled>
                        <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker disabled="false"></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-12" *ngIf="false">
                    <mat-form-field appearance="fill">
                        <mat-label>Fecha final</mat-label>
                        <input matInput [matDatepicker]="picker1" [placeholder]="'Folio final'" disabled>
                        <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- <div class="col-sm-12 mt-4 mb-4">
                    <button mat-flat-button color="primary" class="w-full" (click)="buscarAvanzado()">
                        <mat-icon [svgIcon]="'heroicons_outline:search'"></mat-icon>
                        <span class="ml-2 mr-1">Buscar</span>
                    </button>

                    <button mat-flat-button class="w-full mt-4" (click)="cancelarAvanzado()">
                        <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                        <span class="ml-2 mr-1">Cancelar</span>
                    </button>
                </div> -->
            </div>
        </div>

        <!-- Botones fijos -->
        <div class="p-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
            <button mat-flat-button color="primary" class="w-full" (click)="buscarAvanzado()">
                <mat-icon [svgIcon]="'heroicons_outline:search'"></mat-icon>
                <span class="ml-2 mr-1">Buscar</span>
            </button>
    
            <button mat-flat-button class="w-full mt-4" (click)="cancelarAvanzado()">
                <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                <span class="ml-2 mr-1">Cancelar</span>
            </button>
        </div>
    </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col overflow-hidden">

            <!-- Main -->
            <div class="flex flex-auto overflow-hidden">
                <ng-container *ngIf="true">
                    <div class="flex flex-col flex-auto overflow-y-auto">

                        <ng-container *ngIf="!drawerOpened">
                            <div class="row p-3 sm:py-6 md:px-4 border-b bg-card">
                                <div class="col-sm-6 no-shadown">
                                    <fuse-card class="flex items-center max-w-80 w-full p-6 filter-info">
                                        <mat-icon class="icon-size-12 mr-6"
                                            [svgIcon]="'heroicons_outline:bookmark'"></mat-icon>
                                        <div class="flex flex-col">
                                            <div class="text-2xl font-semibold leading-tight">Lista de Facturas</div>

                                            <div class="text-md text-secondary" *ngIf="parametros.tipoBusqueda == 0">
                                                Último mes</div>
                                            <div class="text-md text-secondary" *ngIf="parametros.tipoBusqueda == 1">
                                                Búsqueda general</div>
                                            <div class="text-md text-secondary" *ngIf="parametros.tipoBusqueda == 2">
                                                Búsqueda avanzada</div>
                                        </div>
                                    </fuse-card>

                                    <!-- <div class="text-2xl tracking-tight leading-none mt-4">Lista de Facturas</div>
                                    <div class="text-secondary">Último mes</div> -->
                                </div>
                                <div class="col-sm-6">
                                    <!-- Main actions -->
                                    <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                                        <!-- Search -->
                                        <div class="flex-auto" *ngIf="configured">
                                            <mat-form-field
                                                class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                                <mat-icon class="icon-size-5" matPrefix
                                                    [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                                <input matInput [formControl]="busquedaGeneral" required
                                                    (keyup.enter)="searchGeneral()"
                                                    [placeholder]="'Buscar por Folio, RFC o Razón Social'">

                                                <!-- Add contact button -->
                                                <button mat-icon-button color="primary" (click)="openSlide()">
                                                    <mat-icon svgIcon="heroicons_outline:adjustments"></mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </ng-container>

                        <div class="row" *ngIf="configured">
                            <div class="col-sm-12">
                                <app-grid-component *ngIf="factlista" 
                                [datos]="facturas" 
                                [columns]="columns"
                                [exportExcel]="exportExcel" 
                                [columnHiding]="columnHiding" 
                                [Checkbox]="Checkbox"
                                [Editing]="Editing" 
                                [Columnchooser]="Columnchooser" 
                                [searchPanel]="searchPanel" 
                                (modificar)='modificar($event.modificar.key)'
                                (datosevent)='datosMessage($event)' 
                                [toolbar]="toolbar" 
                                [totalRegistros]="length" 
                                (archivarCfdi)="archivarCfdi($event)"
                                (duplicarCFDI)='duplicarCFDI($event.duplicarCFDI.key)' 
                                (cancelarCfdi)="cancelarCfdi($event)" 
                                [descargarExcel]="descargarExcel">
                                </app-grid-component>
                            </div>
                        </div>

                        <div class="row" *ngIf="!configured">
                            <div class="col-sm-12">
                                <div class="card p-4 mt-3" *ngIf="!configured">
                                    <!-- Icon Section -->
                                    <div class="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white p-4 mb-4" style="width: 60px; height: 60px; margin: 0 auto;">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon-size-10" style="width: 40px; height: 40px;">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path>
                                        </svg>
                                    </div>
                                
                                    <!-- Title Section -->
                                    <h5 class="card-title text-center">Emisor Requerido</h5>
                                
                                    <!-- Description Section -->
                                    <p class="card-text text-secondary text-center">
                                        Aún no tienes un emisor configurado. Por favor, crea uno para habilitar el acceso a esta sección.
                                    </p>
                                
                                    <!-- Button Section -->
                                    <div class="text-center mt-4">
                                        <a routerLink="/cuenta/nonecompany" class="btn btn-primary">Crear emisor</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-end c-white">
                                        <mat-paginator [length]="length" (page)="handlePageEvent($event)"
                                        *ngIf="length > pageSize"
                                        [showFirstLastButtons]="true"
                                        [hidePageSize]="true"
                                        >
                                        </mat-paginator>
                                    </div>
                                </div>
                        </div>
                                <!-- <app-grid-component *ngIf="factlista" [datos]="facturas" [columns]="columns"
                                    [exportExcel]="exportExcel" [columnHiding]="columnHiding" [Checkbox]="Checkbox"
                                    [Editing]="Editing" [Columnchooser]="Columnchooser" [searchPanel]="searchPanel"
                                    [scroll]="scroll" (messageEvent)="receiveMessage($event)"
                                    (datosevent)='datosMessage($event)' [toolbar]="toolbar"
                                    (modificar)='modificar($event.modificar.key)'
                                    (archivarCfdi)='archivarCfdi($event.archivarCfdi.key)'
                                    (cancelarCfdi)='cancelarCfdi($event.cancelarCfdi.key)'
                                    (estatusCFDI)='estatusCFDI($event.estatusCFDI.key)'
                                    (descargaPDF)='descargaPDF($event.descargaPDF.key)'
                                    (descargaXML)='descargaXML($event.descargaXML.key)'
                                    (sendEmail)='sendEmail($event.sendEmail.key)'
                                    (duplicarCFDI)='duplicarCFDI($event.duplicarCFDI.key)'>
                                </app-grid-component> -->
                            <!-- </div> -->
                        <!-- </div> -->
                    </div>
                </ng-container>
            </div>

        </mat-drawer-content>

    </mat-drawer-container>

</div>
